<div class="entrance" *ngIf="!isMobile">
<div class="button">
<button pButton [id]="'entrance'" (click)="switchToEntraId()" (keydown.enter)="switchToEntraId()"
        [label]="'iaa.authentication.entranceForIAAEmployees' | translate | translate" [rounded]="true"
        class="prime-button button-entra {{ currentLanguage === 'en' ? 'en' : 'he' }}"
        [ariaLabel]="'iaa.authentication.entranceForIAAEmployees' | translate | translate">
        <img src="assets/vector.svg" alt="" class="icon" /> </button>
</div>    
    <div class="numbers">
        <div class="type" (mouseenter)="onIconHover('reshuma', true)" (mouseleave)="onIconHover('reshuma', false)">
            <img class="icon" [src]="getIconSrc('reshuma')" alt="">
            <div class="number">
                {{entityTypeNumbers.Records}}
            </div>
            <div class="type_title"> {{'iaa.authentication.Records' | translate}}
            </div>
        </div>
        <div class="stat-divider"></div>

        <div class="type" (mouseenter)="onIconHover('hefetz', true)" (mouseleave)="onIconHover('hefetz', false)">
            <img class="icon" [src]="getIconSrc('hefetz')" alt="">
            <div class="number">
                {{entityTypeNumbers.Artifacts}}
            </div>
            <div class="type_title"> {{'iaa.authentication.Artifacts' | translate}}
            </div>
        </div>
        <div class="stat-divider"></div>

        <div class="type" (mouseenter)="onIconHover('images', true)" (mouseleave)="onIconHover('images', false)">
            <img class="icon" [src]="getIconSrc('images')" alt="">
            <div class="number">
                {{entityTypeNumbers.Images}}
            </div>
            <div class="type_title"> {{'iaa.authentication.Images' | translate}}
            </div>
        </div>
        <div class="stat-divider"></div>

        <div class="type" (mouseenter)="onIconHover('photogrammetry', true)"
            (mouseleave)="onIconHover('photogrammetry', false)">
            <img class="icon" [src]="getIconSrc('photogrammetry')" alt="">
            <div class="number">
                {{entityTypeNumbers.PhotogrammetryModels}}
            </div>
            <div class="type_title"> {{'iaa.authentication.PhotogrammetryModels' | translate}}
            </div>
        </div>
        <div class="stat-divider"></div>

        <div class="type" (mouseenter)="onIconHover('researchers', true)"
            (mouseleave)="onIconHover('researchers', false)">
            <img class="icon" [src]="getIconSrc('researchers')" alt="">
            <div class="number">
                {{entityTypeNumbers.Researchers}}
            </div>
            <div class="type_title"> {{'iaa.authentication.Researchers' | translate}}
            </div>
        </div>
    </div>
    <div class="picture" [ngClass]="{'intro-expanded': showFullDescription}">
        <img class="vestiges" src="assets/vestiges.jpg" alt="">
        <div class="intro" [ngClass]="{'expanded': showFullDescription}">
            <div class="intro-text">
                <h2 class="intro-title">{{'iaa.authentication.iaaTitle' | translate}}</h2>
                {{'iaa.authentication.iaaDescriptionShort' | translate}}
                <span *ngIf="!showFullDescription" 
                      class="read-more-link" 
                      (click)="toggleDescription()" 
                      (keydown.enter)="toggleDescription()"
                      tabindex="0"
                      role="button"
                      [attr.aria-label]="'iaa.aria.readMore' | translate">
                    {{'iaa.authentication.iaaDescriptionShortRest' | translate}}
                </span>
                <div *ngIf="showFullDescription" class="full-description">
                    <span [innerHTML]="'iaa.authentication.iaaDescriptionRest' | translate"></span>
                    <span [innerHTML]="'iaa.authentication.iaaEmails' | translate: { yoavEmail: yoavEmail, mokediaaEmail: mokediaaEmail } | brToNewLine ">
                        </span>
                    <span class="read-less-link" 
                          (click)="toggleDescription()" 
                          (keydown.enter)="toggleDescription()"
                          tabindex="0"
                          role="button"
                          [attr.aria-label]="'iaa.authentication.hide' | translate">
                        {{'iaa.authentication.hide' | translate}}
                    </span>
                </div>
            </div>
            <div class="terms-container">
                <a [href]="termsLink" target="_blank" rel="noopener noreferrer" class="link-text">
                    {{ 'iaa.authentication.term' | translate }}
                </a>
                <span class="pipe">|</span>
                <a [href]="privacyLink" target="_blank" rel="noopener noreferrer" class="link-text">
                    {{ 'iaa.authentication.privacyPolicy' | translate }}
                </a>
            </div>
            <div class="sentence">{{'iaa.authentication.mobileNotSupported'| translate}}</div>
            <div class="video" (click)="openVideo()" (keydown.enter)="openVideo()" tabindex="0" role="link"
     [attr.aria-label]="('iaa.authentication.video' | translate) + ' (' + ('iaa.aria.opensInNewTab' | translate) + ')'">
                <img src="assets/movie.svg" alt="" class="icon" />
                <span>{{'iaa.authentication.video'|translate}} </span>
            </div>
            <div class="buttons">
            <a
            pButton
            [label]="'iaa.authentication.Selected3DModels' | translate"
            [rounded]="true"
            class="prime-button button-3d {{ currentLanguage === 'en' ? 'en' : 'he' }}"
            [attr.aria-label]="('iaa.authentication.Selected3DModels' | translate) + ' (' + ('iaa.aria.opensInNewTab' | translate) + ')' "
            target="_blank"
            href="{{ getModelsLink() }}"
            role="link">
            </a>
               <button [id]="'entrance'" (click)="loginAsGuest()" (keydown.enter)="loginAsGuest()" pButton
                   [label]="'iaa.authentication.guestEntry' | translate" [rounded]="true"
                   class="prime-button button-b2c {{ currentLanguage === 'en' ? 'en' : 'he' }}"
                   [ariaLabel]="'iaa.authentication.guestEntry' | translate" ></button>
           </div>
        </div>
    </div>
</div>
  <div class="mobile-wrapper" *ngIf="isMobile">
    <div class="mobile-main">
      <div class="numbers">
        <div class="type-mobile" (mouseenter)="onIconHover('reshuma', true)" (mouseleave)="onIconHover('reshuma', false)">
            <img class="icon" [src]="getIconSrc('reshuma')" alt="">
            <div class="number-mobile">
                {{entityTypeNumbers.Records}}
            </div>
            <div class="type_title-mobile"> {{'iaa.authentication.Records' | translate}}
            </div>
        </div>
        
        <div class="stat-divider"></div>
        
        <div class="type-mobile" (mouseenter)="onIconHover('hefetz', true)" (mouseleave)="onIconHover('hefetz', false)">
            <img class="icon" [src]="getIconSrc('hefetz')" alt="">
            <div class="number-mobile">
                {{entityTypeNumbers.Artifacts}}
            </div>
            <div class="type_title-mobile"> {{'iaa.authentication.Artifacts' | translate}}
            </div>
        </div>
        
        <div class="stat-divider"></div>
        
        <div class="type-mobile" (mouseenter)="onIconHover('images', true)" (mouseleave)="onIconHover('images', false)">
            <img class="icon" [src]="getIconSrc('images')" alt="">
            <div class="number-mobile">
                {{entityTypeNumbers.Images}}
            </div>
            <div class="type_title-mobile"> {{'iaa.authentication.Images' | translate}}
            </div>
        </div>
      </div>

      <div class="image-section">
        <img src="assets/vestiges.jpg" alt="" class="bg-image">
        <div class="overlay-content">
            <div class="intro_mobile" [ngClass]="{'expanded': showFullDescription}">
                <div class="intro-text-mobile">
                    <h2 class="intro-title-mobile">{{'iaa.authentication.iaaTitle' | translate}}</h2>
                    {{'iaa.authentication.iaaDescriptionShortMobile' | translate}}
                    <span *ngIf="!showFullDescription" 
                          class="read-more-link-mobile" 
                          (click)="toggleDescription()" 
                          (keydown.enter)="toggleDescription()"
                          tabindex="0"
                          role="button"
                          [attr.aria-label]="'iaa.aria.readMore' | translate">
                        {{'iaa.authentication.iaaDescriptionShortRestMobile' | translate}}
                    </span>
                    <div *ngIf="showFullDescription" class="full-description">
                        <span [innerHTML]="'iaa.authentication.iaaDescriptionRestMobile' | translate"></span>
                        <span [innerHTML]="'iaa.authentication.iaaEmails' | translate: { yoavEmail: yoavEmail, mokediaaEmail: mokediaaEmail } | brToNewLine ">
                        </span><span class="read-less-link-mobile" 
                              (click)="toggleDescription()" 
                              (keydown.enter)="toggleDescription()"
                              tabindex="0"
                              role="button"
                              [attr.aria-label]="'iaa.authentication.hide' | translate">
                            {{'iaa.authentication.hide' | translate}}
                        </span>
                    </div>
                </div>
                <div class="sentence">{{'iaa.authentication.mobileNotSupported'| translate}}</div>
                <div class="video" (click)="openVideo()" (keydown.enter)="openVideo()" tabindex="0" role="link"
     [attr.aria-label]="('iaa.authentication.video' | translate) + ' (' + ('iaa.aria.opensInNewTab' | translate) + ')'">
                    <img src="assets/movie.svg" alt="" class="icon" />
                    <span>{{'iaa.authentication.video'|translate}}</span>
                </div>
            </div>
            <div class="button-section">
                <button pButton [id]="'entrance'" (click)="loginAsGuest()" (keydown.enter)="loginAsGuest()"
                [label]="'iaa.authentication.guestEntry' | translate" [rounded]="true"
                class="prime-button button-b2c-mobile {{ currentLanguage === 'en' ? 'en' : 'he' }}"
                [ariaLabel]="'iaa.authentication.guestEntry' | translate"></button>
                <a
                    pButton
                    [label]="'iaa.authentication.Selected3DModels' | translate"
                    [rounded]="true"
                    [attr.aria-label]="('iaa.authentication.Selected3DModels' | translate) + ' (' + ('iaa.aria.opensInNewTab' | translate) + ')'"
                    target="_blank"
                    class="prime-button button-3d-mobile {{ currentLanguage === 'en' ? 'en' : 'he' }}"
                    href="{{ getModelsLink() }}"
                    role="link">
                </a>
                <!-- <p-button [id]="'entrance'" (click)="switchToEntraId()" (keydown.enter)="switchToEntraId()"
                [label]="'iaa.authentication.entranceForIAAEmployees' | translate | translate" [rounded]="true"
                [styleClass]="'prime-button button-entra-mobile ' + (currentLanguage === 'en' ? 'en' : 'he')"
                [ariaLabel]="'iaa.authentication.entranceForIAAEmployees' | translate | translate">
                </p-button> -->
              </div>
        </div>

      </div>



      <div class="mobile-footer">
        <button pButton [id]="'entrance'" (click)="switchToEntraId()" (keydown.enter)="switchToEntraId()"
        [label]="'iaa.authentication.entranceForIAAEmployees' | translate | translate" [rounded]="true"
        class="prime-button button-entra-mobile {{ currentLanguage === 'en' ? 'en' : 'he' }}"
        [ariaLabel]="'iaa.authentication.entranceForIAAEmployees' | translate | translate">
        <img src="assets/vector.svg" alt="" class="icon" /> </button>

        <div class="footer-text">
            {{'iaa.authentication.footer' | translate}}
            <br>
            <a [href]="termsLink" target="_blank" rel="noopener noreferrer" class="link-text">
                    {{ 'iaa.authentication.term' | translate }}
                </a>
                <span class="pipe">|</span>
                <a [href]="privacyLink" target="_blank" rel="noopener noreferrer" class="link-text">
                    {{ 'iaa.authentication.privacyPolicy' | translate }}
                </a>
        </div>
                
      </div>
    </div>
  </div>
